import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["preview", "fileInput", "removeButton", "cacheField"];
  static values = {
    exists: Boolean,
    noImageUrl: String,
  };

  connect() {
    this.updateUI();
  }

  select(event) {
    const file = event.target.files[0];
    if (!file) return;

    this.revokeCurrentObjectUrl();
    this.currentObjectUrl = URL.createObjectURL(file);
    this.previewTarget.src = this.currentObjectUrl;
    this.existsValue = true;
  }

  remove() {
    this.revokeCurrentObjectUrl();
    this.previewTarget.src = this.noImageUrlValue;
    this.cacheFieldTarget.value = "";
    this.existsValue = false;
  }

  existsValueChanged() {
    this.updateUI();
  }

  updateUI() {
    this.removeButtonTarget.hidden = !this.existsValue;
    if (!this.existsValue) {
      this.fileInputTarget.value = "";
    }
  }

  revokeCurrentObjectUrl() {
    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
      this.currentObjectUrl = null;
    }
  }
}
